import React, {useState,useEffect}  from 'react';

import MissionVisionContent from "../content/MissionVisionContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";
import { Helmet } from "react-helmet-async";

import LoadingBar from 'react-top-loading-bar';

function MissionVision() {

    const [progress, setProgress] = useState(0);
    
    useEffect(()=>{
        setProgress(100);
    },[]);

    return(
        <>
        <Helmet>
            <title>Mission & Vision | Suvivah</title>

            <meta
                name="description"
                content="Discover Suvivah's mission and vision to promote ideal marriages through trust, values, compatibility, and family relationships."
            />

            <meta
                name="keywords"
                content="Mission, Vision, Suvivah, Ideal Marriage"
            />

            <meta name="robots" content="index, follow" />
            <meta name="author" content="Suvivah" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#dc3545" />
            <meta property="og:site_name" content="Suvivah" />
            <meta property="og:locale" content="en_IN" />

            <link rel="canonical" href="https://suvivah.org/mission-vision" />

            <meta property="og:title" content="Mission & Vision | Suvivah" />
            <meta property="og:description" content="Building ideal marriages through trust and values." />
        </Helmet>
        <Navbar />
        <MissionVisionContent/>
        <LoadingBar
            color='#a11800'
            height={4}
            background='#fff4a1'
            loaderSpeed={2000}
            waitingTime={2000}
            shadow={true}
            progress={progress}
            onLoaderFinished={() => setProgress(0)}
        />
        <Footer />        
        </>
    );
}

export default MissionVision;